import React from "react";
import { Card, CardActions, CardContent, CardMedia, Button, Typography, ButtonBase } from "@material-ui/core/";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Post.css";

import { likePost, deletePost } from "../../../actions/posts";
import useStyles from "./styles";
import { useState } from "react";

const Post = ({ post, setCurrentId }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem("profile"));
  const navigate = useNavigate();

  /* since the like takes a while to update, i'm using a setter function to update
    to update the state inmmediately in the frontend, whitouth waiting for the database to update
    handling the like with the handleLikes function.
    This is because updates to the database are asynchronous and can take time
    The alternative is to do it directly in the Likes function using (post.likes) instead of likes hook
    and seeting the onClick of the button to dispatch(likePost(post._id)); */

  const [likes, setLikes] = useState(post?.likes);
  const hasLikedPost = post.likes.find((like) => like === (user?.result?.googleId || user?.result?._id));
  const userLikedId = user?.result.googleId || user?.result?._id;

  const handleLikes = async () => {
    dispatch(likePost(post._id));

    if (hasLikedPost) {
      setLikes(post.likes.filter((id) => id !== userLikedId));
    } else {
      setLikes([...post.likes, userLikedId]);
    }
  };

  const Likes = () => {
    if (likes.length > 0) {
      return likes.find((like) => like === (user?.result?.googleId || user?.result?._id)) ? (
        <>
          <i className="bi bi-hand-thumbs-up-fill"></i>&nbsp;
          {likes.length > 2
            ? `You and ${likes.length - 1} others`
            : `${likes.length} Like${likes.length > 1 ? "s" : ""}`}
        </>
      ) : (
        <>
          <i className="bi bi-hand-thumbs-up"></i>&nbsp;{likes.length} {likes.length === 1 ? "Like" : "Likes"}
        </>
      );
    }
    return (
      <>
        <i className="bi bi-hand-thumbs-up"></i>&nbsp;Like
      </>
    );
  };

  const deleteHandler = (post) => {
    if (window.confirm("Are you sure you want to remove this entry?")) {
      dispatch(deletePost(post._id));
    }
  };

  const openPost = (e) => {
    // dispatch(getPost(post._id, history));

    navigate(`/posts/${post._id}`);
  };

  return (
    <Card className={classes.card}>
      <ButtonBase component="span" name="test" className={classes.cardAction} onClick={openPost}>
        <CardMedia
          className={classes.media}
          image={
            post.selectedFile ||
            "https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png"
          }
          title={post.title}
        />
        <div className={classes.overlay}>
          <Typography className={classes.creator} variant="h6">
            {post.name}
          </Typography>
          <Typography variant="body2">{moment(post.createdAt).fromNow()}</Typography>
        </div>

        {user?.result?.googleId === post?.creator ||
          (user?.result?._id === post?.creator && (
            <div className={classes.overlay2}>
              <Button
                style={{ color: "white" }}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentId(post._id);
                }}
              >
                <i className="bi bi-pencil-square" style={{ fontSize: "18px" }}></i>
              </Button>
            </div>
          ))}

        <div className={classes.details}>
          <Typography variant="body2" color="textSecondary" component="h2">
            {post.tags.map((tag) => `#${tag} `)}
          </Typography>
        </div>
        <Typography className={classes.title} gutterBottom variant="h5" component="h2">
          {post.title}
        </Typography>

        <CardContent>
          <Typography className={classes.message} component="p">
            {post.message.length > 260 ? `${post.message.slice(0, 260)} ...` : `${post.message}`}
          </Typography>
        </CardContent>
      </ButtonBase>

      <CardActions className={classes.cardActions}>
        <button
          disabled={!user?.result}
          className={
            post.likes.find((like) => like === (user?.result?.googleId || user?.result?._id))
              ? "button-card like liked"
              : "button-card like"
          }
          onClick={handleLikes}
        >
          <Likes />
        </button>
        {user?.result?.googleId === post?.creator ||
          (user?.result?._id === post?.creator && (
            <button className="button-card delete" onClick={() => deleteHandler(post)}>
              <i className="bi bi-trash2-fill"></i> Delete
            </button>
          ))}
      </CardActions>
    </Card>
  );
};

export default Post;
